import { useAppScopeFromContext } from 'v5/core/app-scope/_private/AppScopeContext';
import { EnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';
import { useResolvedAppScope } from 'v5/services/internal/AppScopeService/_private/useResolvedAppScope';
import { AppScopeService } from './AppScopeService';

export function createAppScopeService(config: {
  enterpriseService: EnterpriseService;
}): AppScopeService {
  const { enterpriseService } = config;

  return {
    useAppScope() {
      const slugScope = useAppScopeFromContext();
      return useResolvedAppScope(slugScope, enterpriseService);
    },
    useStoredAppScope() {
      return useAppScopeFromContext();
    },
    useOrganizationId() {
      return useAppScopeFromContext().organizationId;
    }
  };
}
